import { createFocusTrap, Options } from 'focus-trap';
import { useEffect, useRef } from 'react';

type Config = {
  focusElm: HTMLElement | null | undefined;
  isActive: boolean;
  onDeactive?: () => void;
  trapOptions?: Options;
};

const useModalFocusTrap = (config: Config) => {
  const trapOptions = useRef(config.trapOptions);
  const deactivateRef = useRef(config.onDeactive);

  trapOptions.current = config.trapOptions;
  deactivateRef.current = config.onDeactive;

  useEffect(() => {
    if (!config.focusElm || !config.isActive) return;
    try {
      const trap = createFocusTrap(
        [config.focusElm, '#ai-chat-portal', '.Toastify'],
        {
          clickOutsideDeactivates: true,
          onPostDeactivate: deactivateRef.current,
          // escapeDeactivates -> handle it outside on the modal component
          // for some reason the event here always shows the "defaultPrevented" as true
          escapeDeactivates: false,
          ...trapOptions.current,
        },
      );

      trap.activate();

      return () => {
        try {
          trap.deactivate();
        } catch (e) {
          console.error('useModalFocusTrap failed to deactivate', e);
        }
      };
    } catch (e) {
      console.error('useModalFocusTrap failed to activate', e);
    }
  }, [config.focusElm, config.isActive]);
};

export default useModalFocusTrap;
